import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "../root/Login";
import {Button, Card, Popconfirm, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import PlantillaModal from "../PlantillaModal";
import PlantillaLista from "../PlantillaLista";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import {GetComandesGeneradesIdPdf} from "../../dao/menudesign/comandes/GetComandesGeneradesIdPdf";
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import { GetPlats } from '../../dao/menudesign/GetPlats';
import { Plat } from '../../model/menudesign/Plat';
import { PlatIngredient } from '../../model/menudesign/PlatIngredient';
import { PlatVariacio } from '../../model/menudesign/PlatVariacio';
import Ingredient from '../../model/menudesign/Ingredient';
import { GetIngredients } from '../../dao/menudesign/GetIngredients';
import Ingredients from './Ingredients';
import IngredientModal from './components/IngredientModal';
import IngredientList from './components/IngredientList';
import PlatModal from './components/PlatModal';
import { GetPlatIngredients } from '../../dao/menudesign/GetPlatIngredients';
import PlatIngredientModal from './components/PlatIngredientModal';
import { GetPlatVariants } from '../../dao/menudesign/GetPlatVariants';
import { DeletePlat } from '../../dao/menudesign/DeletePlat';
import PlatVariacioModal from './components/PlatVariacioModal';


const Plats = () => {
    const titol: string = "Plats";
    const nomPermis: string = "Plats";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Plat[]>([]);
    const [coleccioPI, setDadesPI] = useState<PlatIngredient[]>([]);
    const [ingredientsList, setIngredients] = useState<Ingredient[]>([]);
    const [coleccioPV, setDadesPV] = useState<PlatVariacio[]>([]);
    const [elementSelected, setElementSelected] = useState<Plat>(new Plat());
    const [elementSelectedPI, setElementSelectedPI] = useState<PlatIngredient>(new PlatIngredient());
    const [elementSelectedI, setElementSelectedI] = useState<Ingredient>(new Ingredient());
    const [elementSelectedPV, setElementSelectedPV] = useState<PlatVariacio>(new PlatVariacio());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouElementI, setNouElementI] = useState(false);
    const [nouElementPI, setNouElementPI] = useState(false);
    const [nouElementPV, setNouElementPV] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [visibleIng, setVisibleIng] = useState(true);
    const [visiblePI, setVisiblePI] = useState(true);
    const [visiblePV, setVisiblePV] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());

    const typeColors: { [key: string]: string } = {
        ou: 'magenta',
        pasta: 'lime',
        vegetal: 'orange',
        arrós: 'blue',
        cereal: 'cyan',
        especia: 'purple',
        condiment: 'gold',
        gra: 'volcano',
        verdura: 'green',
        tubercle: 'red',
        fruita: 'geekblue',
        lactic: 'cyan',
        peix: 'yellow',
        'carn vermella': 'pink',
        altres: 'default',
        hortalissa: 'brown',
        'carn blanca': 'white',
    };

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetPlats(page) || [];
        const platingredients = await GetPlatIngredients(page);
        const ingredients = await GetIngredients(page);
        const platvariants = await GetPlatVariants(page);
        setDades(dades);
        setDadesPI(platingredients);
        setIngredients(ingredients);
        setDadesPV(platvariants)
        await setNameFilters(dades);
        await setNameIFilters(ingredients);
        await setTipFiltres(ingredients);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        await DeletePlat(id, page);
        await checkDades();
    }

    function afegirElement(element: Plat, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }

    function togleNouElement(element: Plat, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }
    async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        await checkDades();
    }

    
    function handleCloseModalPI() {
        setNouElementPI(false);
        checkDades();
    }
    function handleCloseModalI() {
        setNouElementI(false);
        checkDades();
    }
    function handleCloseModalPV() {
        setNouElementPV(false);
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Plat[]) {
        const anyNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(anyNames);
    }
    function setNameIFilters(ingredients: Ingredient[]) {
        if (ingredients && ingredients.length > 0) {
            const ingredientNames = ingredients.map((ingredient) => ({
                text: ingredient.nom,
                value: ingredient.nom,
            }));
            setNomFiltres(ingredientNames);
        }
    }

    function setTipFiltres(ingredients: Ingredient[]) {
        if (ingredients && ingredients.length > 0) {
            const uniqueNames = new Set<string>();
            ingredients.forEach((ingredient) => uniqueNames.add(ingredient.tipus));

            const ingredientNames = Array.from(uniqueNames).map((name) => ({
                text: name,
                value: name,
            }));

            setTipusFiltres(ingredientNames);
        }
    }
    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<Plat> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 10,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'ingredients',
            title: 'Ingredients',
            dataIndex: 'ingredients',
            render: (platingredients: Array<PlatIngredient>) => (
            <>
                {platingredients?.map((pi) => {
                const ingredient = ingredientsList.find(i => i.id == pi.id_ingredient);
                if(!ingredient){
                    return null;
                }
                return (
                    <Tag color={Colors.colors.color3} key={pi.id_ingredient}>
                    {ingredient.nom}
                    </Tag>
                );
                })}
            </>
            ),
            width: 15,
        },
        {
            key: 'variacions',
            title: 'Variants',
            dataIndex: 'variacions',
            render: (variacions: Array<PlatVariacio> | null | undefined) => (
                <>
                    {(variacions || [])?.map((variant) => {
                        const alternativa = coleccio.find(p => p.id == variant.id_alternativa);
                        if(!alternativa){
                            return null;
                        }
                        return (
                            <Tag color={Colors.colors.color3} key={variant.id_alternativa}>
                            {alternativa.nom}
                            </Tag>
                        );
                    })}
                </>
                
            ) ,
            width: 15,
        },
        {
            key: 'cost',
            title: 'Cost',
            dataIndex: 'cost',
            render: (cost: number| null | undefined) => cost != null ? cost.toFixed(2) +'€': '-',
            width: 10,
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele, true)}><BiPencil/></Button>
                            {" "}     
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele.id)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                        </>
                    )}
                    <Button title={"Mostrar"} onClick={() => togleNouElement(ele, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];
    const tableProps: TableProps<Plat> = {
        loading
    };

    function modificarDatosForm() {
        //form.setFieldsValue({ remesa: 0 });
    }

    const onChange: TableProps<Plat>['onChange'] =
        (pagination,
            filters,
            sorter,
            extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Plat) => {
        return (
            <PlantillaLista element={ele}/>
        );
    };

    
    async function handleDownload (id: string)  {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(new Plat(), true)}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                rowKey="id"
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {nouElement && (
                        <PlatModal element={elementSelected} onClose={handleCloseModal} visible={nouElement} editar={editar} page={page}/>
                    )}
                    {nouElementPI && (
                        <PlatIngredientModal element={elementSelectedPI} onClose={handleCloseModalPI} visible={nouElementPI} editar={editar} page={page}/>
                    )}
                    {nouElementPV && (
                        <PlatVariacioModal element={elementSelectedPV} onClose={handleCloseModalPV} visible={nouElementPV} editar={editar} page={page}/>
                    )}
                    {nouElementI && (
                        <IngredientModal ingredient={elementSelectedI} onClose={handleCloseModalI} visible={nouElementI} editar={editar} page={page}/>
                    )}
                </div>
            </div>
        );
        } else {
            return (
                <Login/>
            );
        }
};
export default Plats;
